import { render, staticRenderFns } from "./ProjectInput.vue?vue&type=template&id=11f159d4&scoped=true"
import script from "./ProjectInput.vue?vue&type=script&lang=js"
export * from "./ProjectInput.vue?vue&type=script&lang=js"
import style0 from "./ProjectInput.vue?vue&type=style&index=0&id=11f159d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f159d4",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QItemLabel,QRadio});
